module.exports = __webpack_public_path__ + "static/media/pdf.03e47fef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductGridRow/pdf.svg
// module id = 397
// module chunks = 0